/** @jsxImportSource @emotion/react */

import styled from '@emotion/styled'
import { Primary, spacing } from '@sphinx/components-styles'
import { Button } from '../button/button'
import { css, jsx } from '@emotion/react'

export const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  input {
    width: 100%;
  }
`

export const leftPadding = css`
  padding-left: calc(${spacing.s} - 2px);
`

export const rightPadding = css`
  padding-right: calc(${spacing.s} + 2px);
`

export const horizontalPadding = css`
  ${leftPadding}
  ${rightPadding}
`

export const ActionHandler = styled.div`
  position: absolute;
  height: calc(100% - 2px);
  top: 1px;

  &:hover + input:not(:focus):not(:disabled) {
    border: 1px solid ${Primary.navy[100]};
  }
`

export const fromLeft = css`
  left: 1px;
`

export const fromRight = css`
  right: 1px;
`

export const HandlerButton = styled(Button)`
  height: 100%;
  position: relative;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  overflow: hidden;
  &:active:not(:disabled),
  &:focus {
    & svg * {
      fill: ${Primary.orange[100]};
    }
  }
  &:disabled {
    pointer-events: none;
    & svg * {
      fill: ${Primary.navy[20]};
    }
  }

  & svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-75%, -50%);
  }
`
